'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  gameWidth: 1200,
  gameHeight: 800,
  localStorageName: 'phaser-template',
  serverUrl: 'https://phaser-realtime-basic-server.herokuapp.com'
};


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 147
// module chunks = 0